import {compute} from "../../fjsc/src/signals.ts";
import {currentRoute} from "../state.ts";
import {create} from "../../fjsc/src/f2.ts";
import type {NavItem} from "../models/NavItem.ts";
import {Generics} from "./generics.ts";
import {navigate} from "../routing/Router.ts";

export class Nav {
    static navItem(item: NavItem) {
        const active = compute(r => r && r.path === item.path, currentRoute);
        const activeClass = compute((a): string => a ? "active" : "_", active);

        return create("a")
            .classes("button", "flex", "center-items", activeClass)
            .href(window.location.origin + "/" + item.path)
            .target("_blank")
            .onclick((e: MouseEvent) => {
                if (e.button === 0) {
                    e.preventDefault();
                    navigate(item.path);
                }
            })
            .children(
                Generics.icon(item.icon),
                create("span")
                    .text(item.text)
                    .build()
            ).build();
    }
}